<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>库存</el-breadcrumb-item>
      <el-breadcrumb-item>入库</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20" v-if="!auth.isPlatformUser()">
      <h5>待入库采购单</h5>
      <el-table :data="orders" v-loading="loading">
        <el-table-column
          prop="number"
          label="采购单号 / 订单号"
          min-width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.number }}
            <br />
            {{ scope.row.customer_order.number }}
          </template>
        </el-table-column>
        <el-table-column label="产品明细" min-width="200">
          <template slot-scope="scope">
            <span class="item-tag" v-for="item in scope.row.items">
              {{ item.item.name }}
              <i>x{{ item.count }}</i>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="user.name"
          label="创建人"
          align="center"
        ></el-table-column>
        <el-table-column prop="date" label="创建日期" align="center">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.created_at) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
        ></el-table-column>
        <el-table-column align="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleNewByPurchaseOrder(scope.row)"
              v-permission="Auth.stockInNew"
              >生成入库单</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="panel mt-20">
      <h5 style="margin-bottom: 15px">入库单列表</h5>
      <div class="header mb-10">
        <!-- <el-button @click="handleNew(1)" icon="el-icon-plus" type="primary" size="small">采购单入库</el-button> -->
        <el-button
          @click="handleNew(2)"
          icon="el-icon-plus"
          type="primary"
          size="small"
          v-permission="Auth.stockInNew"
          >普通入库</el-button
        >
      </div>
      <el-table
        v-loading="loading"
        :data="lists"
        stripe
        header-row-class-name="q-products-header"
      >
        <el-table-column
          label="入库类型 / 采购单号"
          min-width="200px"
          v-if="!auth.isPlatformUser()"
        >
          <template slot-scope="scope">
            {{ scope.row.category_id == 2 ? '普通入库' : '采购单入库' }}
            <br />
            {{ scope.row.order_number }}
          </template>
        </el-table-column>
        <el-table-column label="产品明细" min-width="200">
          <template slot-scope="scope">
            <span class="item-tag" v-for="item in scope.row.items">
              {{ item.item.name }}
              <i>x{{ item.item_number }}</i>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="stockroom.name"
          label="仓库"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="transactor.name"
          label="经办人"
          align="center"
        ></el-table-column>
        <el-table-column label="入库时间" align="center">
          <template slot-scope="scope">{{
            scope.row.stock_in_date
              ? $time(scope.row.stock_in_date).format('YYYY-MM-DD')
              : ''
          }}</template>
        </el-table-column>
        <el-table-column label="总金额" align="center">
          <template slot-scope="scope">{{
            scope.row.amount.toFixed(2)
          }}</template>
        </el-table-column>
        <el-table-column align="right" label="操作" width="150px">
          <template slot-scope="scope">
            <el-popconfirm
              v-permission="Auth.stockInCheck"
              title="确认入库吗？"
              @confirm="handleStatusCheck(scope.$index, scope.row.id)"
            >
              <el-button slot="reference" type="primary" plain size="mini"
                >入库</el-button
              >
            </el-popconfirm>
            <el-button
              size="mini"
              type="primary"
              plain
              @click="showBillDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleEdit(scope.row, scope.$index)"
              v-permission="Auth.stockInEdit"
              >编辑</el-button
            >
            <el-popconfirm
              title="确认删除吗？"
              @confirm="handleDelete(scope.row, scope.$index)"
              v-permission="Auth.stockInDelete"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <stock-in-former
      :model="dataForm"
      :show.sync="dialogVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></stock-in-former>
    <bill-detail-dialog
      :model="showModel"
      :show.sync="detailDialogVisible"
    ></bill-detail-dialog>
  </div>
</template>

<script>
import stockInFormer from '@/components/stock_in'
import billDetailDialog from '@/components/bill_detail'
import {
  stockInBillList,
  stockInBillCheck,
  deleteStockInBill,
  purchaseOrderList,
} from '@/service/getData'
import { clone } from '@/util'
import { formatTime } from '@/util/index'
import auth from '@/util/auth'

export default {
  components: {
    stockInFormer,
    billDetailDialog,
  },
  data() {
    return {
      auth,
      tab: 'orderList',
      orders: [],
      loading: true,
      page: 0,
      size: 30,
      lists: [],
      formatTime: formatTime,
      dataForm: {
        category_id: '',
        purchase_order_id: '',
        order_number: '',
        stockroom_id: '',
        transactor_id: '',
        stock_in_date: new Date(),
        remark: '',
        items: [],
      },
      dialogVisible: false,
      detailDialogVisible: false,
      showModel: {},
    }
  },
  created() {
    this.initData()
    this.requestOrders()
  },
  methods: {
    async initData() {
      const pagination = { page: 0, size: 1000 }
      let res = await stockInBillList({
        page: this.page,
        size: this.size,
        status: 1,
      })
      this.lists = res.data.list
      this.loading = false
    },
    async requestOrders() {
      let res = await purchaseOrderList({
        page: 0,
        size: 2000,
        status: 7,
        resource_not_filter: true,
      })
      if (res.code == 0) {
        this.orders = res.data.list
      }
    },
    async handleStatusCheck(index, id) {
      let res = await stockInBillCheck(id)
      if (res.code == 0) {
        this.$message({
          message: '入库成功',
          type: 'success',
          center: true,
        })
        this.lists.splice(index, 1)
      }
    },
    showBillDetail(item) {
      this.showModel = item
      this.detailDialogVisible = true
    },
    handleNew(category_id) {
      this.dialogVisible = true
      this.dataForm = {
        category_id: category_id,
        purchase_order_id: '',
        order_number: '',
        stockroom_id: '',
        transactor_id: '',
        stock_in_date: new Date(),
        remark: '',
        items: [],
      }
    },
    handleNewByPurchaseOrder(row) {
      let items = row.items.map((i) => {
        let item = i.item
        item.price = i.price
        item.number = i.count
        return item
      })

      this.dialogVisible = true
      this.dataForm = {
        category_id: 1,
        purchase_order_id: row.id,
        order_number: row.number,
        stockroom_id: '',
        transactor_id: '',
        stock_in_date: new Date(),
        remark: '',
        items: items,
        init_order: true,
      }
    },
    handleEdit(item, index) {
      this.editIndex = index
      this.dialogVisible = true
      this.$nextTick(() => {
        this.dataForm = clone(item)
        this.dataForm.items.map((it) => {
          it.id = it.item.id
          it.number = it.item_number
          it.price = it.unit_price
          it.category = it.item.category
          it.name = it.item.name
          it.part_number = it.item.part_number
          it.machine_type = it.item.machine_type
        })
        if (this.dataForm.purchase_order_id == 0) {
          this.dataForm.purchase_order_id = ''
        }
        if (this.dataForm.transactor_id == 0) {
          this.dataForm.transactor_id = ''
        }
      })
    },
    createdCallback(data) {
      this.lists.unshift(data)
      this.requestOrders()
    },
    updatedCallback(data) {
      this.$set(this.lists, this.editIndex, data)
    },
    async handleDelete(item, index) {
      let res = await deleteStockInBill(item.id)
      if (res.code == 0) {
        this.lists.splice(index, 1)
        this.requestOrders()
      }
    },
  },
}
</script>
<style scoped>
.tag {
  float: left;
  max-width: 100%;
  text-overflow: ellipsis;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  border: 1px solid #ccc;
  font-size: 12px;
  margin: 2px 0;
  clear: both;
  background-image: linear-gradient(to right, #98c9fd55, #fff);
}
.tag i {
  margin-left: 10px;
}
h5 {
  font-size: 14px;
}
</style>
